export default function PasswordCriteria() {
  
  return (
    <div id = "password_criteria">
      <span></span>
      <span id ="number_criteria"> Contains A Number</span>
      <br/>
      <span id="upper_criteria"> Contains A Uppercase</span>
      <br/>
      <span id="special_criteria"> Contains A Special</span>
      <br/>
      <span id = "character_criteria"> Contains 9 Characters</span>
    </div>
  )
}